import { themeSpaces } from '../../../theme/foundations';
import { BackgroundStyle } from './Toast.theme.utils';
export var toastTheme = {
  baseStyle: _ref => {
    var {
      type,
      isMobile
    } = _ref;
    return {
      container: {
        minWidth: 'auto',
        marginTop: isMobile ? themeSpaces.m : themeSpaces.xl,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0
      },
      toast: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: isMobile ? 'space-between' : 'center',
        gap: 's',
        borderRadius: 'l',
        height: '48px',
        width: isMobile ? "calc(100vw - ".concat(themeSpaces.s, " * 2)") : 'max-content',
        maxWidth: '400px',
        boxShadow: 500,
        paddingX: 's',
        color: 'neutral.white',
        bgColor: BackgroundStyle[type]
      },
      content: {
        flexGrow: 1,
        textStyle: 'body4',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    };
  },
  defaultProps: {
    type: 'info'
  }
};
//# sourceMappingURL=Toast.theme.js.map